'use strict';

/**
 * Converts a string to lowercase.
 *
 * @param {String} s The string.
 * @returns {String} A new string.
 * @example
 *
 * import { toLower } from 'fkit'
 * toLower('FOO') // foo
 */
function toLower(s) {
  return s.toLowerCase();
}

module.exports = toLower;
